<img [ngSrc]="bgPath" fill>
<div style="width: 100%; height: 100%;" class="divLogin">
    <div class="form-card">
        <h1 style="text-align: center; margin-top: 64px; font-size:xx-large; color: white;">ABOPI</h1>
        <mat-divider style="margin: 48px;"></mat-divider>

        <mat-card class="cardLogin">

            <mat-card-title style="text-align: center; margin: 16px; color: white" >Se connecter</mat-card-title>
            <mat-card-content>
                <form [formGroup]="formLogin">
                    <div class="row">
                        <mat-form-field appearance="fill">
                            <mat-label>Nom d'utilisateur</mat-label>
                            <input matInput formControlName="username">
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field appearance="fill">
                            <mat-label>Mot de passe</mat-label>
                            <input matInput type="password" formControlName="password" type="password">
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <button [disabled]="formLogin.invalid" type="submit" mat-raised-button color="primary" style="width: 50%; height: 50px;" (click)="login()">Login</button>
                    </div>
                </form>
                <div style="display: flex; justify-content: center; margin-top: 32px;">
                  <button mat-button color="primary" (click)="forgottenPassword()">Mot de passe oublié ?</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

    <ngx-spinner
      bdColor="rgba(0,0,0,0.8)"
      size="medium"
      color="#fff"
      type="ball-spin-clockwise"
      [fullScreen]="true">
    </ngx-spinner>
